import { Base } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Thumbs, Mousewheel, FreeMode } from 'swiper/modules';

/**
 * Slider component
 */
export default class Gallery extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Gallery',
    refs: ['slider', 'thumbs'],
  };

  /**
   *
   */
  mounted() {
    if (this.$refs.thumbs) {
      this.thumbs = new Swiper(this.$refs.thumbs, {
        modules: [FreeMode, Mousewheel],
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
      });
    }

    this.slider = new Swiper(this.$refs.slider, {
      modules: [Thumbs],
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 8,
      grabCursor: true,
      thumbs: {
        swiper: this.thumbs ?? null,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          centeredSlides: false,
          spaceBetween: 0,
        },
      },
    });
  }

  /**
   *
   */
  destroyed() {
    this.slider?.destroy(true, true);
    this.thumbs?.destroy(true, true);
  }
}
